"use strict";
'use es6';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.reducerNamespace = void 0;
var reducerNamespace = 'settings-content-modals';
exports.reducerNamespace = reducerNamespace;